import angular from 'angular'
import modalAddAsk from './add-ask.html'

let FaqListController = function (Faq, Categorie, $mdDialog, $filter, $scope, $state, Toast) {
  let $ctrl = this;
  $ctrl.$scope = $scope;
  angular.extend($ctrl, {
    edit,
    deleteDialog,
  });

  const formatCategory = el => {
    return {
      id: el.id,
      name: el.name,
      subcategories: el.subcategories
    }
  }

  activate();

  function activate() {
    $ctrl.resources = {
      count: 0,
      data: []
    };

    $ctrl.categories = []

    $ctrl.uiState = 'LOADING';
    $ctrl.category = {
      name: ''
    }

    $ctrl.versionList = [];

    $ctrl.promise;

    $ctrl.$scope.tableConfig = {
      order: 'updated_at'
    };

    $ctrl.$scope.$watch('tableConfig', () => {
      loadData()
      loadCategories()
    }, true);
  }

  function edit(resource) {
    $mdDialog.show({
      template: modalAddAsk,
      controller: ($scope, $mdDialog) => {
        "ngInject";
        $scope.loadingText = 'Carregando';
        $scope.categories = $ctrl.categories.map(formatCategory);
        $scope.isEditing = resource && resource.id;

        $scope.faq = angular.copy(resource) || {
          question: '',
          response: '',
          categorie: { id: null, name: null },
          subcategorie: { id: null, name: null },
          is_visible_app: 0,
          is_visible_shop: 0,
          is_visible_webchat: 0,
        }

        $scope.handleChange = function (id) {
          $scope.subCategories = $scope.categories.find(el => el.id === id).subcategories;
        };

        if (resource && resource.categorie && resource.subcategorie) {
          $scope.handleChange(resource.categorie.id);
        } else {
          $scope.subCategories = []
        }

        $scope.hide = function () {
          $mdDialog.hide();
        };

        $scope.cancel = function () {
          $mdDialog.cancel();
        };

        $scope.save = function (resource) {
          $mdDialog.hide(resource);
        }
      },
      bindToController: true,
      clickOutsideToClose: true,
      fullscreen: false
    })
      .then(function (resource) {
        resource.id ? update(resource) : saveData(resource)
      }, function () {
        $scope.status = 'You cancelled the dialog.';
      });
  }

  function deleteDialog(resource) {
    $mdDialog.show({
      template: '<md-dialog aria-label="Version dialog" style="max-width: 550px; padding: 24px;">' +
      '  <md-dialog-content>'+
      '  <h4><strong>EXCLUIR VERSÃO</strong></h4>' +
      '  <div>Deseja realmente excluir a versão selecionada?</div>' +
      '  </md-dialog-content>' +
      '  <md-dialog-actions>' +
      '    <md-button ng-click="cancel()">Cancelar</md-button>' +
      '    <md-button ng-click="save()" class="md-accent">Excluir</md-button>' +
      '  </md-dialog-actions>' +
      '</md-dialog>',
      controller: DialogController,
      bindToController: true,
      clickOutsideToClose: true,
      fullscreen: false
    })
      .then(function () {
        deleteData(resource.id);
      }, function () {
        $scope.status = 'You cancelled the dialog.';
      });
  }

  function DialogController($scope, $mdDialog) {
    "ngInject";
    $scope.loadingText = 'Carregando';
    $scope.categories = $ctrl.categories;
    $scope.subCategories = [];

    $scope.handleChange = function (resource) {
      $scope.subCategories = $scope.categories.find(el => el.id === resource.id).subcategories;
    };

    $scope.hide = function () {
      $mdDialog.hide();
    };

    $scope.cancel = function () {
      $mdDialog.cancel();
    };

    $scope.save = function (resource) {
      $mdDialog.hide(resource);
    }
  }

  // Local functions

  function loadData() {
    $ctrl.promise = Faq
      .load($ctrl.$scope.tableConfig)
      .then(response => {
        setPlaceHolderValues(response.data);
        $ctrl.resources = response;
        $ctrl.uiState = response.data.length ? 'COMPLETE' : 'EMPTY';
        $ctrl.$scope.$apply();
      })
      .catch(err => {
        $ctrl.uiState = 'ERROR';
      });
  }

  function loadCategories() {
    $ctrl.promise = Categorie.index()
    .then(response => {
      $ctrl.categories = response;
      $ctrl.uiState = response.data.length ? 'COMPLETE' : 'EMPTY';
      $ctrl.$scope.$apply();
    })
    .catch(err => {
      $ctrl.uiState = 'ERROR';
    });
  }

  function setPlaceHolderValues(arr) {
  	_.forEach(arr, item => {
  		if (item.email === null || item.email === undefined) {
  			item.email = $filter('translate')('common-not-informed');
  		}
  	});
  }

  function saveData(resource) {
    const category = $ctrl.categories.find(el => el.id === resource.categorie.id);

    resource.categorie_id = category ? category.id : null;
    resource.subcategorie_id = resource.subcategorie.id
      ? category.subcategories.find((el) => el.id === resource.subcategorie.id)
          .id
      : null;
    
    delete resource.categorie
    delete resource.subcategorie

    $ctrl.promise = Faq
      .save(resource)
      .then(response => {
        loadData()
      })
      .catch(err => {
        if(err.status === 400) {
          $mdDialog.show(
            $mdDialog.alert()
            .clickOutsideToClose(true)
            .textContent("A pergunta já existe, necessário criar uma pergunta diferente!")
            .ok("Ok")
          )
        }
        else{
          $ctrl.uiState = 'ERROR';
        }
      }).finally(()=>{
        $ctrl.notification = {
          version: null,
          plataform: ''
        }
      })
  }

  function update(resource) {
    const updatedResponse = {
      question: resource.question,
      title: resource.question,
      categorie_id: resource.categorie ? resource.categorie.id : null,
      subcategorie_id: resource.subcategorie ? resource.subcategorie.id : null,
      is_visible_app: resource.is_visible_app,
      is_visible_shop: resource.is_visible_shop,
      is_visible_website: resource.is_visible_website,
      response: resource.response,
    }

    $ctrl.promise = Faq
      .update(resource.id, updatedResponse)
      .then(response => {
        loadData()
      })
      .catch(err => {
        $ctrl.uiState = 'ERROR';
      }).finally(()=>{
        $ctrl.notification = {
          version: null,
          plataform: ''
        }
      })
  }

  function deleteData(id) {
    $ctrl.promise = Faq
      .deleteData(id)
      .then(response => {
        loadData()
      })
      .catch(err => {
        $ctrl.uiState = 'ERROR';
      }).finally(()=>{
        $ctrl.notification = {
          version: null,
          plataform: ''
        }
      })
  }
}

FaqListController.$inject = ['Faq', 'Categorie', '$mdDialog', '$filter', '$scope', '$state', 'Toast'];

export default FaqListController;



// WEBPACK FOOTER //
// ./client/app/components/faq/faq-list.controller.js